import { isUndefined } from 'lodash';

export const isIE11 = (browserWindow = window as any) => {
  return !isUndefined((browserWindow as any).ActiveXObject) && 'ActiveXObject' in (browserWindow as any) ? true : false;
};
